export default __webpack_public_path__ + "static/media/gtd8.fd124e9c.jpg";